import { calcSimpleMaxPoints } from "../_common/pointsCalculationHelper";

export const calculateMaxPoints = (answer) => {
  if (answer.lineEvaluation()) {
    return calcSimpleMaxPoints(answer);
  }

  const q = answer.question();
  return q.realQuestionsCount() * Number(q.points());
};
